import { ELSS_Data_RESPONSE, ELSS_Data_RESPONSE_FAIL, ELSS_PDFDOWNLOAD_RESPONSE, ELSS_PDFDOWNLOAD_RESPONSE_FAIL } from "../types/elssReport";

const initialState = {
    elssData: {},
    elssPdfDownload: {},
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case ELSS_Data_RESPONSE:
            return { ...state, elssData: action.payload }
        case ELSS_Data_RESPONSE_FAIL:
            return { ...state, elssData: action.payload }
        case ELSS_PDFDOWNLOAD_RESPONSE:
            return { ...state, elssPdfDownload: action.payload }
        case ELSS_PDFDOWNLOAD_RESPONSE_FAIL:
            return { ...state, elssPdfDownload: action.payload }
        default:
            return state
    }
}